import { remToPixelRatio } from '../../../constants/Styling';

import styles from './constants.scss';

export const RowItemButtonType = Object.freeze({
  PLAY: 'play',
  PAUSE: 'pause',
  PLUS: 'plus',
});

export const RowItemEllipsisActions = ['click', 'contextmenu'];

export const RowItemHeights = Object.freeze({
  SMALL: parseFloat(styles.ROW_ITEM_HEIGHT_SMALL) * remToPixelRatio,
  DEFAULT: parseFloat(styles.ROW_ITEM_HEIGHT_DEFAULT) * remToPixelRatio,
  LARGE: parseFloat(styles.ROW_ITEM_HEIGHT_LARGE) * remToPixelRatio,
});
